// extracted by mini-css-extract-plugin
export var chevronIcon = "_aw-2";
export var teamName = "_aw-1";
export var teamSwitcherButton = "_aw-0";